import { Grid } from "@amzn/awsui-components-react";
import * as React from "react";
import "../../styles/util-styles.scss";
import "../../styles/home-page/instance-home-widgets.scss";
import "../../styles/home-page/responsive.scss";
import "bootstrap/dist/css/bootstrap.min.css";

const HOMEPAGE_RECOMMENDATIONS = [
    {
        id: "rec-1",
        title: "Amazon Legal",
        description: "Amazon Legal Team Home Page",
        url: "https://legal.amazon.com/Pages/Home.aspx"
    },
    {
        id: "rec-2",
        title: "AWS Legal",
        description: "AWS Legal Team Home Page",
        url: "https://pathfinder.legal.amazon.dev/#/instance/AWSLegal/home"
    },
    {
        id: "rec-3",
        title: "BC&E Legal",
        description: "The Business Conduct & Ethics (BCE) team’s mission is to foster Amazon’s ethical business culture and prevent, identify, and mitigate fraud and corruption risk to Amazon",
        url: "https://pathfinder.legal.amazon.dev/#/instance/bce/home"
    }
];

const truncate = (text: string, maxLength: number) =>
    text.length > maxLength ? text.substring(0, maxLength) + "..." : text;

export const HomePageRecommendationWidget = () => (
    <div className="recommendation-widget-main">
        <div className="recommendation-widget-title">
            Recommended&nbsp;&nbsp;&nbsp;for&nbsp;&nbsp;&nbsp;You
        </div>
        <div className="card-deck" style={{ zIndex: 300 }}>
            <Grid className="homepage-responsive" gridDefinition={[
                { colspan: { default: 12, s: 4 } },
                { colspan: { default: 12, s: 4 } },
                { colspan: { default: 12, s: 4 } },
            ]}>
                {HOMEPAGE_RECOMMENDATIONS.map(({ id, title, description, url }) => (
                    <a
                        key={id}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="card recommendation-card"
                        style={{ textDecoration: "none", cursor: "pointer" }}
                    >
                        <div className="card-body recommendation-card-body">
                            <h5 className="card-title text-center">
                                {truncate(title, 50)}
                            </h5>
                            <p className="card-text">{truncate(description, 150)}</p>
                        </div>
                    </a>
                ))}
            </Grid>
        </div>
    </div>
);